import {Component, Input, OnInit} from '@angular/core';
import {AppService} from '../../../../services/app.service';

@Component({
  selector: 'app-my-coupons',
  templateUrl: './my-coupons.component.html',
  styleUrls: ['./my-coupons.component.css']
})
export class MyCouponsComponent implements OnInit {

  // Show More Less Text
  more = true;
  showDetails = false;
  value = 'fnpr15rg';
  public couponData;

  @Input()
  get data(): string {
    return this.couponData;
  }

  set data(data: any) {
    this.couponData = data;
  }

  constructor(
    public appService: AppService
  ) {
  }

  ngOnInit(): void {
  }


  viewDetails(): void {
    this.more = !this.more;
    this.showDetails = !this.showDetails;
  }


}
